import axiosV2, { apiPost } from '../core/http/axios_api_v2';
import hasPermission from '../core/acl/acl';

export default {



    createCancelledHeshbonit(taxDocumentNumber) {

        return apiPost('tax-documents/createCancelledHeshbonit', { taxDocumentNumber });
    },

    // Hebrew names of the payment fields - the toast names the failing field, not just "a field"
    paymentFieldNames: {
        sum: 'סכום',
        bank: 'בנק',
        snif: 'מספר סניף',
        bankAccountNumber: 'מספר חשבון',
        checkNumber: 'מספר צ׳ק',
        date: 'תאריך',
        tashlumim: 'מספר תשלומים',
        creditCardType: 'סוג כרטיס',
        creditCardDealType: 'סוג עסקה',
        soleketCompany: 'חברה סולקת',
        businessBankAccount: 'חשבון מקבל',
    },

    // The business's own accounts (the חשבון מקבל of a bank transfer) live in the business settings.
    // With none defined there is nothing to pick - say so, and say where it is fixed (a user who may
    // not edit the settings is sent to someone who can).
    missingBusinessBankAccountMessage() {

        let bankAccounts = planup.$store.state.businessSettings.bankAccounts;

        if (bankAccounts && bankAccounts.length)
            return 'נא לבחור את חשבון הבנק של העסק שאליו הועבר התשלום';

        return hasPermission(planup.$store.getters.getUser, 'settings.view')
            ? 'לא הוגדר חשבון בנק לעסק - הוסיפו חשבון דרך "ניהול מהיר" (או בהגדרות ← רשות המיסים ← חשבונות בנק)'
            : 'לא הוגדר חשבון בנק לעסק - בקשו ממנהל העסק להוסיף חשבון בהגדרות ← רשות המיסים ← חשבונות בנק';
    },

    // "העברה בנקאית (תשלום 2)" and one line per failing field with its reason - the toast used to say
    // only that "the fields are invalid" while the page scrolled away from them
    describePaymentErrors(payment, paymentErrors, paymentIndex) {

        let problems = Object.keys(paymentErrors)
            .filter(field => paymentErrors[field])
            .map(field => `${this.paymentFieldNames[field] || field}: ${paymentErrors[field]}`);

        let where = (payment.paymentType && payment.paymentType.name) || 'אמצעי תשלום';

        if (typeof paymentIndex == 'number')
            where += ` (תשלום ${paymentIndex + 1})`;

        return `<b>${where}</b><br>${problems.join('<br>')}`;
    },

    validatePayment(component, payment, paymentIndex) {

        let paymentErrors = {};

        paymentErrors.sum = !payment.sum ? 'ערך לא תקין' : null;


        switch (payment.paymentType.value) {

            case 1: //cash
                //nothing to validate
                break;

            case 2: //cheque
                paymentErrors.bank = !payment?.bank?.value ? 'שדה חובה' : null;
                paymentErrors.snif = !payment.snif || payment.snif <= 0 ? 'ערך לא תקין' : null;
                paymentErrors.bankAccountNumber = !payment.bankAccountNumber || payment.bankAccountNumber <= 0 ? 'ערך לא תקין' : null;
                paymentErrors.checkNumber = !payment.checkNumber || payment.checkNumber <= 0 ? 'ערך לא תקין' : null;
                paymentErrors.date = !payment.date ? 'שדה חובה' : null;
                break;

            case 3: // credit card
                paymentErrors.tashlumim = !payment.tashlumim || payment.tashlumim <= 0 ? 'ערך לא תקין' : null;
                paymentErrors.creditCardType = !payment?.creditCardType?.value ? 'שדה חובה' : null;
                paymentErrors.creditCardDealType = !payment?.creditCardDealType?.value ? 'שדה חובה' : null;
                paymentErrors.soleketCompany = !payment?.soleketCompany?.value ? 'שדה חובה' : null;
                paymentErrors.date = !payment.date ? 'שדה חובה' : null;
                break;

            case 4: //bank transfer
                paymentErrors.businessBankAccount = !payment.businessBankAccount ? this.missingBusinessBankAccountMessage() : null;
                paymentErrors.date = !payment.date ? 'שדה חובה' : null;
                paymentErrors.bank = !payment.bank ? 'שדה חובה' : null;
                paymentErrors.bankAccountNumber = !payment.bankAccountNumber ? 'שדה חובה' : null;
                paymentErrors.snif = !payment.snif ? 'שדה חובה' : null;
                break;

        }


        component.$set(payment, 'errors', paymentErrors);

        //this checks if there is at least one field with an error
        let paymentIsValid = !Object.values(paymentErrors).some(value => value);

        if (!paymentIsValid)
            planup.$globals.notifyFormError(this.describePaymentErrors(payment, paymentErrors, paymentIndex), 'חסרים פרטים באמצעי התשלום');

        return paymentIsValid;

    },




    create(event, taxDocumentType, createTaxDocumentParams, hideSuccessAlert) {

        // an edited edition (הזמנה מעודכנת / הצעת מחיר מעודכנת) doesn't move the deal's status: a
        // signed order stays signed until the customer signs the new edition or the user changes it,
        // and a re-quote doesn't send the deal back to "הצעת מחיר נשלחה"
        if (taxDocumentType == 'hatsaatMehir' && !createTaxDocumentParams.reviseTaxDocumentId) {
            planup.$handlers.eventHandler.updateStatus(event, 'priceOfferSent');
        }

        if (taxDocumentType == 'hazmana' && !createTaxDocumentParams.cancelOrderId && !createTaxDocumentParams.reviseTaxDocumentId) {
            planup.$handlers.eventHandler.updateStatus(event, 'hazmanaSent');
        }

        return apiPost(`tax-documents/create/${taxDocumentType}`, createTaxDocumentParams, hideSuccessAlert)
    },


    // Document types an issued copy of which can be edited into a new edition (1343/2 - הזמנה
    // מעודכנת, הצעת מחיר מעודכנת). Mirrors TaxDocumentsService.REVISABLE_TYPES.
    REVISABLE_TYPES: ['hazmana', 'hatsaatMehir'],

    isRevisableType(type) {
        return this.REVISABLE_TYPES.includes(type);
    },

    // The Hebrew names an editable type goes by in the edition texts: the bare name (עריכת הזמנה,
    // הזמנה זו הוחלפה / הצעת מחיר זו) and the definite form (עריכת ההזמנה / עריכת הצעת המחיר)
    revisableTypeNames(type) {
        return type == 'hatsaatMehir'
            ? { name: 'הצעת מחיר', definite: 'הצעת המחיר' }
            : { name: 'הזמנה', definite: 'ההזמנה' };
    },


    // Did the customer sign this document? `signatures` is the json the signing page stored: the
    // contact id → drawn image pairs, plus the ip / useragent / time the server adds. A row holding
    // only those three (שמור with nothing drawn, which the signing page accepted until 10/2026) is
    // not a signature - the document can still be signed. Mirrors the `signed` flag of
    // GET tax-documents/revisions.
    isSigned(taxDocument) {

        let signatures = taxDocument && taxDocument.signatures;

        if (typeof signatures == 'string') {
            try { signatures = JSON.parse(signatures); } catch (e) { return false; }
        }

        if (!signatures || typeof signatures != 'object')
            return false;

        return Object.keys(signatures).some(key => typeof signatures[key] == 'string' && signatures[key].indexOf('data:image/') === 0);
    },


    // The number a document shows everywhere (page title, order list, tables, reports): the series
    // number, plus "/<edition>" on a revised הזמנה / הצעת מחיר (1343/2). Mirrors
    // TaxDocumentsService.formatNumber and Pdf::getDocNumber - keep the three in step.
    formatNumber(taxDocument) {

        if (!taxDocument || taxDocument.taxDocumentNumber === null || taxDocument.taxDocumentNumber === undefined)
            return '';

        return +taxDocument.revision > 1 ? `${taxDocument.taxDocumentNumber}/${taxDocument.revision}` : `${taxDocument.taxDocumentNumber}`;
    },

    // הזמנה מעודכנת / הצעת מחיר מעודכנת: a document's family (original + editions), which is the
    // standing one and the number the next edit would print -
    // { rootId, type, taxDocumentNumber, editions, currentId, nextNumber }
    async getRevisions(taxDocumentId) {
        return (await axiosV2(`tax-documents/revisions/${taxDocumentId}`)).data;
    },


    get(taxDocumentId,pdfId) {
        return axiosV2(`tax-documents/${taxDocumentId}?pdfId=${pdfId || ''}`);
    },

    async getPreviewPdfId(taxDocumentType, createTaxDocumentParams) {

        return (await axiosV2({ method: 'post', url: `tax-documents/preview/${taxDocumentType}`, data: createTaxDocumentParams })).data
    },

    async getNextNumber(type) {
        return (await axiosV2(`tax-documents/nextNumber/${type}`)).data;
    },

    // חשבונית חלקית: { dealTotalAfterVat, invoicedAfterVat, paidOutsideAfterVat, remainingAfterVat, documents }
    async getInvoicedSummary(eventId) {
        return (await axiosV2(`tax-documents/invoicedSummary/${eventId}`)).data;
    },

    getTaxDocumentTitle(taxDocument) {

        return planup.$store.state.taxDocumentTypes.find(t => taxDocument.type == t.value).name + ' ' + this.formatNumber(taxDocument);
    },

    generateLocalTaxDocumentPayment(payments, totalPrice, howMuchWasPaid = 0) {

        let sumOfPayments = 0;
        payments?.map(payments => sumOfPayments += payments.sum)

        return {
            // paymentType:window.planup.$store.state.taxDocumentPaymentTypes[0],
            sum: totalPrice - sumOfPayments - howMuchWasPaid,
            paymentType: {

            }

        }
    },


    // The document one more payment on a deal gets: a חשבונית מס קבלה opened in חשבונית חלקית mode
    // (partial=1) - one 'תשלום על חשבון' line for the money received now, the deal's services table
    // untouched and the deal / billed-so-far / balance strip on the page - or a plain קבלה for an
    // עוסק פטור, who issues no tax invoices. { to, label, type } for a router-link.
    paymentDocumentLink(customerId, eventId) {

        let osekPatur = !!(planup.$store.state.businessSettings && planup.$store.state.businessSettings.osekPatur);
        let type = osekPatur ? 'kabala' : 'heshbonitMasKabala';

        let to = `/createTaxDocument?type=${type}&customerId=${customerId}`;

        if (eventId)
            to += `&eventId=${eventId}`;

        if (!osekPatur)
            to += '&partial=1';

        return { to, type, label: osekPatur ? 'קבלה על תשלום' : 'חשבונית מס קבלה על תשלום' };
    },


    // event: the one open on the customer page - without it the document page takes the
    // customer's FIRST event, the wrong one for a customer with several
    goToAddTaxDocumenToCustomer(customer, taxDocumentType, event) {
        let eventPart = event && event.id ? `&eventId=${event.id}` : '';
        planup.$router.push(`/createTaxDocument?customerId=${customer.id}&type=${taxDocumentType.value}${eventPart}`)
    },



    createGoToFunctionForFindCustomer(taxDocumentType) {

        return (searchResult) => {

            planup.$router.push(`/createTaxDocument?customerId=${searchResult.customerId}&eventId=${searchResult.eventId}&type=${taxDocumentType.value}`)

        }

    },








}